// extracted by mini-css-extract-plugin
export default {"toggle":"MockServerToggle_toggle__2oqdU"};